import { useSyncExternalStore } from 'react';

export type Route = { page: 'landing' } | { page: 'pricing' } | { page: 'status' };

const LANDING: Route = { page: 'landing' };
const PRICING: Route = { page: 'pricing' };
const STATUS: Route = { page: 'status' };

let cachedHash = '';
let cachedRoute: Route = LANDING;

function getRoute(): Route {
  const pathname = window.location.pathname.replace(/\/+$/, '');
  if (pathname.endsWith('/pricing')) {
    return PRICING;
  }
  if (pathname.endsWith('/status')) {
    return STATUS;
  }
  const hash = window.location.hash;
  if (hash === cachedHash) return cachedRoute;
  cachedHash = hash;
  cachedRoute = LANDING;
  return cachedRoute;
}

function subscribe(cb: () => void): () => void {
  window.addEventListener('hashchange', cb);
  window.addEventListener('popstate', cb);
  return () => {
    window.removeEventListener('hashchange', cb);
    window.removeEventListener('popstate', cb);
  };
}

export function useHashRoute(): Route {
  return useSyncExternalStore(subscribe, getRoute, () => LANDING);
}
